import { defineMessages } from 'react-intl'

export default defineMessages({
  errorsPresent: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.errorsPresent',
    defaultMessage: 'Must be filled out',
  },
  successToastr: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.successToastr',
    defaultMessage: 'Successfully merged {toBeMergedCustomerName} into {customerName}',
  },
  modalTitle: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.modalTitle',
    defaultMessage: 'Customer Merger',
  },
  selectCustomerLabel: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.selectCustomerLabel',
    defaultMessage: 'Select customer to be merged into {customerName}',
  },
  noCustomerSelected: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.noCustomerSelected',
    defaultMessage: 'None',
  },
  selectCustomerDescription: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.selectCustomerDescription',
    defaultMessage: 'The selected customer({toBeMergedCustomerName}) will be merged into {customerName}',
  },
  submit: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.submit',
    defaultMessage: 'Merge',
  },
  loading: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.loading',
    defaultMessage: 'Merging..',
  },
  disclaimer: {
    id: 'containers.CustomerPage.CustomerInfo.Actions.MergeCustomer.disclaimer',
    defaultMessage: 'Are you sure you want to merge {toBeMergedCustomerName} into {customerName}?\nThis action is not reversible and can not be undone!',
  },
})
